import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ApiService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';

import { MatDialog } from '@angular/material';
import { AlertComponent } from '@angular/synthrone-design/components';

@Component({
  selector: 'app-organizations-components-view',
  templateUrl: './organizations-components-view.component.html',
  styleUrls: ['./organizations-components-view.component.scss']
})

export class OrganizationsComponentsViewComponent implements OnInit {

  @ViewChild('componentsTable') componentsTable;

  configColumns = {
    title: {
      label: 'Component Name',
      sortable: false,
      truncate: true,
      style: {
        flexGrow: 0.5
      }
    }
  };

  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
  timeout = null;
  organizationPlanet: String;
  previewImage: String = 'assets/images/component_preview_placeholder.png';
  tableFilter:any  = {
      'search': '',
      'type': ''
  }
  counters: any = {
    'enabled': 0,
    'private': 0,
    'public': 0
  };

  constructor(private _router: Router, private route: ActivatedRoute, protected api: ApiService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog, private cdRef:ChangeDetectorRef) { }

  ngOnInit() {
      this.organizationPlanet = this.route.snapshot.params['planet']
      this.tableFilter = {
          'search': (typeof this.queryParams['search'] === "undefined") ? this.tableFilter.search : this.queryParams['search'],
          'type': (typeof this.queryParams['type'] === "undefined") ? this.tableFilter.type : this.queryParams['type']
      }
  }

  setParams = () => {
      Object.keys(this.tableFilter).forEach((key) => {
        if (this.tableFilter[key]) {
          this.queryParams[key] = this.tableFilter[key];
        } else {
          delete this.queryParams[key];
        }
      });
  };

  refreshTable = () => {
      this.componentsTable.getData()
  };

  getComponents = (limit, offset, sortBy, sortOrder): Observable<any> => {
      let params:any = {
        seed: new Date().getTime(),
        offset: offset,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
        client: this.organizationPlanet
      };

      if (this.tableFilter.search) {
        params.filterValue = this.tableFilter.search;
      }
      if (this.tableFilter.type) {
        params.type = this.tableFilter.type;
      }
      return this.api.makeRequest('api_system_component_list', params, 'crafter').flatMap((result:any) => {
        this.counters = result.counters;
        this.cdRef.detectChanges();
        return Observable.of(result);
      });
  }

  updateEnabledHeader = () => {
    const enabledHeader = document.querySelector('mat-header-cell.mat-column-enabled');
    enabledHeader.innerHTML = `${this.counters.enabled}/${this.counters.private} enabled`;
    this.cdRef.detectChanges();
  }

  toggleComponent = (componentType, componentName) => {
    const overlay = document.createElement('div');
    const slider:any = event.target;
    const row = slider.closest('.mat-row');
    const endpoint = (slider.checked) ? 'api_system_component_enable' : 'api_system_component_disable';

    overlay.className = 'requestOverlay';
    overlay.innerHTML = '<div class="loader"></div>';
    overlay.addEventListener('click', () => { event.stopPropagation() });
    row.appendChild(overlay);

    this.api.makeRequest(endpoint, {
      client: this.organizationPlanet,
      type: componentType,
      name: componentName
    }, 'crafter').subscribe(
      (result) => {
        row.removeChild(overlay);
        (slider.checked) ? this.counters.enabled++ : this.counters.enabled--;
        this.updateEnabledHeader();
      },
      (error) => {
        row.removeChild(overlay);
      });
  }

  rowClicked = (row) => {
    const clickedElement:any = event.target;
    const clickedRow = (clickedElement.classList.contains('mat-cell') ? clickedElement.parentElement : clickedElement);
    const activeRow = document.querySelector('.active-row');
    if (!clickedRow.classList.contains('active-row')) {
      if (activeRow) {
        activeRow.classList.remove('active-row');
      }
      clickedRow.classList.add('active-row');
      this.previewImage = row.thumbnail;
    }
  }

  searchProductFN = () => {

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setParams();
        this._router.navigate(['/organizations/components/' + this.organizationPlanet + '/1/10/'], { relativeTo: this.route, queryParams: this.queryParams });
        this.refreshTable();
      }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/views/organizations-components-view/organizations-components-view.component.ts